import { render, staticRenderFns } from "./Fyresult.vue?vue&type=template&id=1451fda5&scoped=true"
import script from "./Fyresult.vue?vue&type=script&lang=js"
export * from "./Fyresult.vue?vue&type=script&lang=js"
import style0 from "./Fyresult.vue?vue&type=style&index=0&id=1451fda5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1451fda5",
  null
  
)

export default component.exports